export default __webpack_public_path__ + "static/media/cheveron-left.8d49867d.svg";